<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  mounted() {
    this.renderChart(
      {
        labels: [
          "Ocak",
          "Şubat",
          "Mart",
          "Nisan",
          "Mayıs",
          "Haziran",
        ],
        datasets: [
          {
            label: "Yeni Eklenen Abone Sayısı",
            data: [7, 10, 5, 9, 0, 6],
            backgroundColor: "transparent",
            borderColor: "#28a745",
            pointBackgroundColor: "#007bff"
          },
          {
            label: "Pasif Edilen Abone Sayısı",
            data: [2, 0, 2, 1, 0, 0],
            backgroundColor: "transparent",
            borderColor: "#ffc107",
            pointBackgroundColor: "#007bff"
          },
          {
            label: "İptal Edilen Abone Sayısı",
            data: [0, 3, 1, 0, 4, 0],
            backgroundColor: "transparent",
            borderColor: "#dc3545",
            pointBackgroundColor: "#007bff"
          },
        ]
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: "Abone Raporu"
        }
      }
    );
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/General/Reports/components/LineChart.vue